import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StatusSolved = function StatusSolved(props) {
  return /*#__PURE__*/ _jsxs(
    "svg",
    _extends(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
      },
      props,
      {
        children: [
          /*#__PURE__*/ _jsx("path", {
            d: "M10 1.91388C14.4689 1.91388 18.0861 5.5311 18.0861 10C18.0861 14.4689 14.4689 18.0861 10 18.0861C5.5311 18.0861 1.91388 14.4689 1.91388 10C1.91388 5.5311 5.5311 1.91388 10 1.91388ZM10 0C4.48804 0 0 4.48804 0 10C0 15.512 4.48804 20 10 20C15.512 20 20 15.512 20 10C20 4.48804 15.512 0 10 0Z",
            fill: "#47CD89",
          }),
          /*#__PURE__*/ _jsx("path", {
            d: "M10.0001 3.24414C6.26807 3.24414 3.24414 6.26806 3.24414 10.0001C3.24414 13.7322 6.26807 16.7561 10.0001 16.7561C13.7322 16.7561 16.7561 13.7322 16.7561 10.0001C16.7561 6.26806 13.7322 3.24414 10.0001 3.24414ZM14.2011 7.93314L9.08146 13.0623C8.94749 13.1963 8.76567 13.2633 8.58385 13.2633C8.40203 13.2633 8.22979 13.1963 8.09582 13.0623L5.79917 10.7657C5.52165 10.4882 5.52165 10.048 5.79917 9.77046C6.07668 9.49294 6.5073 9.50251 6.78481 9.77046L8.58385 11.5791L13.2154 6.94749C13.4929 6.66998 13.9331 6.66998 14.2011 6.94749C14.4786 7.21543 14.4786 7.66519 14.2011 7.93314Z",
            fill: "#17B26A",
          }),
        ],
      }
    )
  );
};
export default StatusSolved;
